<template>
	<div class="comp">
		<div class="compContent">
			<div class="title">
				<div class="titleL">接诊列表</div>
				<div class="titleR"></div>
			</div>
			<div class="content">
				<div class="con">
					<div class="tabLine">
						<div class="tabLineL">
							<div class="tabItem" :class="[tabIndex===0?'active':'']" @click="changeTabIndex(0)">全部</div>
							<div class="tabItem" :class="[tabIndex===1?'active':'']" @click="changeTabIndex(1)">待接诊</div>
							<div class="tabItem" :class="[tabIndex===2?'active':'']" @click="changeTabIndex(2)">诊疗中</div>
							<div class="tabItem" :class="[tabIndex===3?'active':'']" @click="changeTabIndex(3)">已完成</div>
							<!-- <div class="tabItem" :class="[tabIndex===4?'active':'']" @click="changeTabIndex(4)">诊疗结束</div> -->
						</div>
						<div class="tabLineR"></div>
					</div>
					<div class="searchLine">
						<div class="searchLineL">
							<el-input style="width:250px;margin-right: 10px;" placeholder="请输入顾客名称或手机号" v-model="search.keyword" @keyup.enter.native="clickSearch" clearable size="small"></el-input>
							<el-button @click="clickSearch" type="warning" size="small">搜索</el-button>
							<div class="searchLabel">时间</div>
							<el-date-picker style="width:240px" @change="changeSearch" v-model="datetimerange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" size="small">
							</el-date-picker>
						</div>
						<div class="searchLineR"></div>
					</div>
					<div class="elTable">
						<el-table :data="tableData" style="width: 100%" height="100%" @sort-change="changeSort" :default-sort = "{prop: 'createTime', order: 'descending'}">
							<el-table-column label="挂号单号" prop="recordId" min-width="160">
							</el-table-column>
							<el-table-column label="顾客" prop="memberName" min-width="100">
							</el-table-column>
							<el-table-column label="手机号" prop="memberMobile" min-width="100">
							</el-table-column>
							<el-table-column label="宠物昵称" prop="petName" min-width="100">
							</el-table-column>
							<el-table-column label="品种" prop="typeName" min-width="70">
							</el-table-column>
							<el-table-column label="性别" min-width="50">
								<template slot-scope="props">
									<div>{{props.row.sex}}</div>
								</template>
							</el-table-column>
							<el-table-column label="年龄" prop="birthDay" min-width="80">
								<template slot-scope="props">
									<div>{{$public.FAge(props.row.birthDay)[0]}}岁{{$public.FAge(props.row.birthDay)[1]}}月</div>
								</template>
							</el-table-column>
							<el-table-column label="医生" prop="doctorName" min-width="80">
								<template slot-scope="props">
									<div v-if="props.row.doctorName">{{props.row.doctorName}}</div>
									<div v-else>--</div>
								</template>
							</el-table-column>
							<el-table-column label="挂号时间" min-width="120" :sortable="'custom'" prop="createTime">
								<template slot-scope="props">
									<div>{{$public.FTime(props.row.createTime,'YYYY-MM-DD HH:mm')}}</div>
								</template>
							</el-table-column>
							<el-table-column label="状态" min-width="60">
								<template slot-scope="props">
									<div style="color:#FD4E4E">{{props.row.status==1?'待接诊':''}}</div>
									<div style="color:#18A44C">{{props.row.status==2?'已接诊':''}}</div>
									<div style="color:#949494">{{props.row.status==3?'已完成':''}}</div>
								</template>
							</el-table-column>
							<el-table-column label="备注" prop="remark" min-width="120">
							</el-table-column>
							<el-table-column label="操作" min-width="150">
								<template slot-scope="props">
									<el-button type="text" size="mini" @click="see(props.row)">
										查看
									</el-button>
									<el-button
										v-show="$buttonAuthority('yewu-yiliaoxin-jiezhen')"
										v-if="props.row.status==1&&(!props.row.doctorId||loginInfo.staffId===props.row.doctorId)"
										type="text" @click="jiezhen(props.row)" size="mini">
										接诊
									</el-button>
									<el-button
									v-show="$buttonAuthority('yewu-yiliaoxin-jiezhen')"
										v-if="props.row.status==1&&(props.row.doctorId&&loginInfo.staffId!==props.row.doctorId)"
										type="text" disabled size="mini">
										接诊
									</el-button>
									<el-button
									v-show="$buttonAuthority('yewu-yiliaoxin-editjiezhen')"
										v-if="props.row.status==2"
										type="text" @click="toBingliEdit(props.row)" size="mini">
										编辑
									</el-button>
									<el-button
									v-show="$buttonAuthority('yewu-yiliaoxin-del')"
										v-if="props.row.status===1"
										type="text" @click="del(props.row)" size="mini">
										删除
									</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
				<div class="pageBox">
					<page style="padding:10px 0;" :total="page.total" :page="page.page" @change="changePage"></page>
				</div>
			</div>
		</div>
		<el-dialog title="" :visible.sync="dialogJiezhen_state" width="30%">
			<div>
				<el-form ref="form" label-width="80px">
					<el-form-item label="接诊医生: ">
						<div class="xmjBox">
							<div class="xmjItem" :class="curDoctor===item.userId?'active':''" @click="curDoctor = item.userId" v-for="(item) in doctorList" :key="item.userId">
								{{item.userName}}
							</div>
						</div>
						<!-- <el-select v-model="curDoctor" placeholder="请选择" size="mini">
							<el-option v-for="item in doctorList" :key="item.userId" :label="item.userName" :value="item.userId"> </el-option>
						</el-select> -->
					</el-form-item>
				</el-form>
				<div style="font-size: 16px;padding-left:10px;padding-bottom: 10px;">确定要用以上医生接诊吗？</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogJiezhen_state = false" size="mini">取 消</el-button>
				<el-button type="primary" @click="submit_jiezhen" size="mini">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
	import page from "../../../../components/page.vue"
	export default {
		components:{page},
		data(){
			return{
				tabIndex:0,
				search:{
					status:0,
					is_mine:false,
					keyword:'',
					begin_time:'',
					end_time:'',
					doctor:''
				},
				datetimerange:'',
				tableData:[],
				desc:true,
				page:{
					page:1,
					pageSize:10,
					total:0
				},
				
				curRow:null,
				dialogJiezhen_state: false,
				doctorList:[],
				curDoctor:'',
				
			}
		},
		computed:{
			loginInfo(){
				return this.$store.state.userInfo
			},
			userInfo(){
				return this.$store.state.yiliaoxin.userInfo
			},
			curPetInfo(){
				let obj = this.$store.getters["yiliaoxin/curPetInfo"]
				return obj
			},
			jiezhenParams(){
				return this.$store.state.yiliaoxin.jiezhenParams;
			},
			bingliParams(){
				return this.$store.state.yiliaoxin.bingliParams;
			},
		},
		beforeRouteEnter(to,from,next){
			if(from.path==='/yiliaoxin/guahaoAdd'||from.path==='/yiliaoxin/bingliEdit'){
				next(vm=>{
					vm.getTableData();
				})
			}else{
				next()
			}
		},
		created(){
			this.page.page = this.jiezhenParams.curPage||1
			let tabIndex = this.$route.query.tabIndex;
			if(!this.$public.isNull(tabIndex)){
				this.tabIndex = tabIndex
				this.search.status = Number(tabIndex)
			}
		},
		mounted(){
			this.getDoctorList();
			this.tabIndex = this.jiezhenParams.initialDataOflist.tabIndex||this.tabIndex;
			this.search = this.jiezhenParams.initialDataOflist.search||this.search;
			this.datetimerange = this.jiezhenParams.initialDataOflist.datetimerange||this.datetimerange;
			this.page = this.jiezhenParams.initialDataOflist.page||this.page;
			this.getTableData();
		},
		methods: {
			// see
			see(row){
				this.jiezhenParams.curRow = row
				this.jiezhenParams.type = 'see'
				this.$store.commit("yiliaoxin/set_jiezhenParams",this.jiezhenParams)
				this.$store.commit("yiliaoxin/add_router",{name:'接诊',data:this.jiezhenParams})
			},
			// 跳转编辑页面
			toBingliEdit(row){
				row.caseNumber = row.recordId
				this.bingliParams.curRow = row
				this.bingliParams.type = "edit"
				this.$store.commit("yiliaoxin/set_bingliParams",this.bingliParams)
				this.$store.commit('yiliaoxin/set_curBusiness','病例')
				this.$store.commit("yiliaoxin/add_router",{name:'病例',data:this.bingliParams})
			},
			clickSearch(){
				this.page.page=1;
				this.getTableData()
			},
			changeSearch(){
				this.page.page=1;
				this.getTableData()
			},
			// 删除
			del(row){
				this.$confirm('确定要删除?', '警告', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.delete('/api/Registration/Delete', {recordId:row.recordId}).then(res => {
						if (res.code == 0) {
							this.$message({
								message: '删除成功',
								type: 'success'
							});
							this.$store.dispatch("yiliaoxin/get_NotMedicalCount")
							this.getTableData()
						}
					})
				})
			},
			// 切换列表
			changeTabIndex(index){
				if(index==3){
					this.search.is_mine = true
				}else{
					this.search.is_mine=false
				}
				this.tabIndex=index;
				this.search.status=index;
				this.page.page=1;
				this.getTableData()
			},
			// 改变分页
			changePage(num){
				this.jiezhenParams.curPage = num
				this.$store.commit("yiliaoxin/set_jiezhenParams",this.jiezhenParams)
				this.page.page = num;
				this.getTableData();
			},
			getTableData(){
				let loading=this.$loading();
				let params = {
					"status": this.search.status, // 1待接诊；2诊疗中；3已完成
					"is_mine": this.search.is_mine,
					"begin_time": "",
					"end_time": "",
					isPay:1,
					desc:this.desc,
					"pageIndex": this.page.page,
					"pageSize": this.page.pageSize,
					"keyword": (this.search.keyword).trim()
				}
				if(this.datetimerange&&this.datetimerange.length==2){
					params.begin_time=(''+new Date(this.datetimerange[0]).getTime()).substr(0,10);
					params.end_time=(''+new Date(this.datetimerange[1]).getTime()).substr(0,10);
				}
				console.log(params)
				this.$http.post('/api/Registration/List', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.tableData = res.data.data;
						this.page.total = res.data.count;
						this.replaceRouter()
					}
				})
			},
			replaceRouter(){
				this.jiezhenParams.initialDataOflist = {
					tabIndex:this.tabIndex,
					search:this.search,
					datetimerange:this.datetimerange,
					page:JSON.parse(JSON.stringify(this.page)),
				}
				this.$store.commit("yiliaoxin/set_jiezhenParams",JSON.parse(JSON.stringify(this.jiezhenParams)))
				this.$store.commit("yiliaoxin/replace_router",{name:'接诊',data:JSON.parse(JSON.stringify(this.jiezhenParams))})
			},
			// 挂号顺序
			changeSort(val){
				if(val.order==='ascending'){
					this.desc = false
					this.getTableData();
				}else if(val.order==='descending'){
					this.desc = true
					this.getTableData();
				}else{
					this.desc = false
					this.getTableData();
				}
			},
			// 接诊
			jiezhen(row){
				this.curRow = row;
				let curDoctor = ''
				for(let i=0;i<this.doctorList.length;i++){
					if(this.doctorList[i].userId === this.loginInfo.staffId){
						curDoctor = this.loginInfo.staffId;
					}
				}
				this.curDoctor = curDoctor;
				this.dialogJiezhen_state = true;
			},
			submit_jiezhen(){
				if(this.$public.isNull(this.curDoctor)){
					this.$message({
						message: '请选择接诊医生',
						type: 'error'
					});
					return ;
				}
				let params = {
					recordId:this.curRow.recordId,
					doctorId:this.curDoctor,
					doctorName:this.$public.getMatchingItem(this.doctorList,'userId',this.curDoctor).userName,
				}
				this.$http.get('/api/Case/ReceptionCase', params).then(res => {
					if (res.code == 0) {
						this.$message({
							message: '接诊成功',
							type: 'success'
						});
						this.dialogJiezhen_state = false;
						this.getTableData()
						this.$store.commit('yiliaoxin/set_curBusiness','病例')
						this.bingliParams.type="edit"
						this.bingliParams.curRow=res.data
						this.$store.commit('yiliaoxin/set_bingliParams',this.bingliParams)
						this.$store.commit("yiliaoxin/add_router",{name:'病例',data:this.bingliParams})
						this.$store.dispatch("yiliaoxin/get_NotMedicalCount")
					}
				})
			},
			getDoctorList() {
				// let params = {
				// 	"date": '', // 10位时间戳
				// }
				// this.$http.get('/api/Registration/DutyForDay', params).then(res => {
				// 	if (res.code == 0) {
				// 		this.doctorList = res.data;
				// 	}
				// })
				let params = {
					"pageIndex": 1,
					"pageSize": 100,
					"keyword": "",
					"shopId": this.$store.state.shopId,
					"position": "医生",
					"status": '',
				}
				this.$http.post(process.env.VUE_APP_Url_8000 +'/api/staffinfo/list', params).then(res => {
					if (res.code == 0) {
						let d = res.data.data;
						this.doctorList = []
						for(let i=0;i<d.length;i++){
							this.doctorList.push({
								companyId: "",
								departments: null,
								id: '',
								introduce: "",
								scheduleDate: "",
								shopId: '',
								typeId: '',
								userId: d[i]._id,
								userName: d[i].basic_info.real_name,
							})
						}
					}
				})
			},
		},
		// beforeDestroy(){
		// 	this.jiezhenParams.initialDataOflist = {
		// 		tabIndex:this.tabIndex,
		// 		search:this.search,
		// 		datetimerange:this.datetimerange,
		// 		page:JSON.parse(JSON.stringify(this.page)),
		// 	}
		// 	this.$store.commit("yiliaoxin/set_jiezhenParams",JSON.parse(JSON.stringify(this.jiezhenParams)))
		// },
	}
</script>
<style scoped lang="scss">
	.comp{
		position: relative;height: 100%;box-sizing: border-box;
		.compContent{
			height: 100%;background-color: #fff;border-radius: 12px;overflow: auto;
			.title{
				display: flex;height: 47px;line-height: 27px;border-bottom:1px solid #f2f2f2;padding:10px 18px;box-sizing: border-box;
				.titleL{
					width:50%;font-size: 14px;font-weight: bold;
				}
				.titleR{
					width:50%;
				}
			}
			.content{
				position: relative;padding:0px 0 50px;width:100%;height: calc(100% - 47px);box-sizing: border-box;
				.con{
					width:100%;height: 100%;
					.tabLine{
						height:60px;padding:16px 20px 12px;box-sizing: border-box;display: flex;justify-content: space-between;
						.tabLineL{
							display: flex;
							.tabItem{
								width:90px;text-align: center;line-height: 32px;border-radius: 19px;background-color: #f7f7f7;color:#73737B;font-size: 14px;margin-right: 20px;border:1px solid transparent;cursor: pointer;
								font-weight: bold;
								&.active{
									color:$mainColor;background-color: #FFF9F3;border-color:$mainColor;
								}
							}
						}
						.tabLineR{
							
						}
					}
					.searchLine{
						padding:8px 20px 20px;box-sizing: border-box;display: flex;
						.searchLineL{
							display: flex;
							.searchLabel{
								font-size: 14px;margin-right: 5px;color:$fontColor;line-height:32px;margin-left:10px;
							}
						}
						.searchLineR{
							
						}
					}
					.elTable{
						height: calc(100% - 121px);
					}
				}
				.pageBox{
					position: absolute;bottom:0;width:100%;
				}
			}
		}
		.xmjBox{
			display: flex;justify-content: flex-start;padding:10px 0px 10px;flex-wrap: wrap;
			.xmjItem{
				position: relative;width:92px;box-sizing: border-box;line-height: 30px;text-align: center;border:1px solid #F7F8FA;font-size: 14px;cursor: pointer;margin-bottom: 16px;margin-right: 16px;border-radius: 16px;background-color: #F7F8FA;
				&.active{
					background-color: #FFF9F3;border-color:$mainColor;color:$mainColor;
				}
			}
		}
	}
</style>
